// AppRoutes.jsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MainLayout from '../layout/MainLayout/MainLayout';
import Home from '../pages/Home/Home';
import Products from '../pages/Products/Products';
import Booking from '../pages/Booking/Booking';
import Login from '../pages/Login/Login';
import Register from '../pages/Register/Register';
import Profile from '../pages/Profile/Profile';

const AppRoutes = () => {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      
      <Route path="/" element={
        <MainLayout>
          <Home />
        </MainLayout>
      } />
      
      <Route path="/products" element={
        <MainLayout>
          <Products key="products" />
        </MainLayout>
      } />
      
      <Route path="/booking" element={
        <MainLayout>
          <Booking key="booking" />
        </MainLayout>
      } />
      
      <Route path="/profile" element={
        <MainLayout>
          <Profile key="profile" />
        </MainLayout>
      } />
      
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;